import { useState, useEffect } from "react";
import QrReader from "react-qr-scanner";
import { Grid, Typography } from "@mui/material";
import useFormStyles from "../../styles/useFormStyles";
import { useDispatch } from "react-redux";
import { memberActions } from "../../redux/slices/memberSlice";
import { APIConstants } from "../../constants/ApiConstants";
import axios from "axios";
import Loader from "./Loader";
import { useTheme } from "@mui/material/styles";
import CancelIcon from "@mui/icons-material/Cancel";
import { loyaltyPointsActions } from "../../redux/slices/UpdateLoyaltyPoints";
import { useNavigate } from "react-router";

const QRScanner = () => {
  const formStyles = useFormStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [qrResponse, setQrResponse] = useState<any>(null);
  const [statusMessage, setStatusMessage] = useState<string>(
    "Scan QR to search member"
  );
  const [memberNotFound, setMemberNotFound] = useState<boolean>(false);
  const [loyaltyId, setLoyaltyId] = useState("");
  const theme = useTheme();

  const handleError = (error: any) => {
    console.error("error", error);
  };

  const handleScan = (result: any) => {
    if (result) {
      setQrResponse(result);
    }
  };

  useEffect(() => {
    const validateQR = async () => {
      if (qrResponse) {
        try {
          setLoading(true);
          setMemberNotFound(false);
          setStatusMessage("");
          const getQRString = await axios.post(
            process.env.REACT_APP_API_URL + `${APIConstants.qrValidate}`,
            {
              text: qrResponse.text,
            }
          );
          const res = getQRString.data.id;
          res && setLoyaltyId(res);
        } catch (error) {
          setLoading(false);
          setMemberNotFound(true);
          setStatusMessage("Invalid QR Code, Scan again");
          setQrResponse(null);
        } finally {
        }
      }
    };
    validateQR();
  }, [qrResponse]);

  useEffect(() => {
    if (loyaltyId) {
      getMemberDetails(loyaltyId);
    }
  }, [loyaltyId]);

  const getMemberDetails = async (query: any) => {
    try {
      setMemberNotFound(false);
      setLoading(true);
      setStatusMessage("Fetching member...");
      const memberDetails = await axios.get(
        process.env.REACT_APP_API_URL +
          `${APIConstants.getCustomer}?externalId=${query}`
      );
      const data = memberDetails?.data?.data?.data;
      if (data?.email) {
        navigate(`/viewMember`);
        dispatch(
          memberActions.updateMemberList({
            membersList: data,
          })
        );

        dispatch(
          loyaltyPointsActions.updatePoints({
            points: data.loyaltyPoints,
          })
        );
      } else {
        setMemberNotFound(true);
        setLoading(false);
        setStatusMessage("Member no found");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMemberNotFound(true);
      setStatusMessage("Member not found");
      console.error("error", error);
    }
  };

  return (
    <Grid
      // my={12}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      gap={1}
    >
      {loading ? (
        <Grid
          mt={4}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {loading && <Loader size={23} />}
          {memberNotFound && (
            <CancelIcon
              sx={{ fontSize: "2rem", color: theme?.color?.failure }}
            />
          )}
        </Grid>
      ) : (
        <QrReader
          delay={500}
          style={{
            width: "27vw",
            height: "40vh",
            objectFit: "fill",
            borderRadius: "8px",
          }}
          onError={handleError}
          onScan={handleScan}
        />
      )}
      <Typography sx={{ ...formStyles.formLabel }} mx={2}>
        {statusMessage}
      </Typography>
    </Grid>
  );
};

export default QRScanner;
